module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_13.7c74680457c547c1b315031f47f621fa.png";